<template lang="pug">

div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-desktop-8
      .column
        p.u-text-lg {{$t('formDesc')}}


  section.u-mt-lg
    ValidationObserver(ref="observer")
      form(slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)" novalidate)
        .grid.is-tablet-8.is-widescreen-6
          .column
            TextInput(
              v-model="fname"
              type="text"
              :label="$t('forms.fname')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="lname"
              type="text"
              :label="$t('forms.lname')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="email"
              type="email"
              :label="$t('forms.email')"
              rules="required|email"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="phone"
              type="text"
              :label="$t('forms.phoneNumber')"
              rules="required|numeric"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="street"
              type="text"
              :label="$t('forms.streetAddress')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="city"
              type="text"
              :label="$t('forms.city')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="county"
              type="text"
              :label="$t('forms.county')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="state"
              type="text"
              :label="$t('forms.stateProvince')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="zip"
              type="text"
              :label="$t('forms.zip')"
              rules="required"
              :disabled="isSubmitting"
            )

            TextInput(
              v-model="franchise"
              type="text"
              :label="$t('forms.whereFranchise')"
              rules="required"
              :disabled="isSubmitting"
            )
        button.button-link.is-medium(v-load="isSubmitting") {{$t('formCta')}}

  .u-mb-md
</template>

<script>
import { mapActions } from 'vuex';
import { load } from '~/directives';
import TextInput from '~/components/inputs/TextInput';
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    TextInput,
    ValidationObserver
  },
  directives: {
    load
  },
  data: () => ({
    fname: '',
    lname: '',
    email: '',
    street: '',
    city: '',
    county: '',
    state: '',
    zip: '',
    franchise: '',
    isSubmitting: false
  }),
  methods: {
    ...mapActions({
      success: 'alert/success',
      error: 'alert/error'
    })
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Franchise",
    "pageDesc":"Become one of Baianat franchisors and start your business with a strategic partner that supports your rapid growth.",
    "mantra":"Let’s build a great |business, together.",
    "formDesc":"The completion of this form is to receive information about franchise opportunities only and does not obligate you to purchase a franchise.",
    "formCta":"Let’s partner."
  },
  "ar": {
    "pageTitle":"حق الإمتياز من بيانات ",
    "pageDesc":"لدعم حقيقي يسير بأعمالك نحو النمو والازدهار، ومن أجل تبادل مثمر للخبرات، احصل على حق الامتياز من بيانات كخطوة نحو النجاح",
    "mantra":"معًا لنبني عملًا |ناجحًا.",
    "formDesc":"استكمال هذا النموذج هو من أجل الحصول على معلومات حول فرص حق الامتياز فقط ولا يلزمك بشراء حق الامتياز.",
    "formCta":"لنكن شركاء!"

  }
}
</i18n>
